export enum StatusConnexionEnum {
    notYet = 0,
    connected = 1,
    refused = 2
}
